export default {
  state: () => ({
    combos: [],
  }),
  getters: {
    combos: state => {
      return state.combos;
    }
  },
  actions: {
    async fetchCombos({ commit }) {
      const { data } = await this.$http.get(`/combos`);
      commit("setCombos", data);
    },
    async addCombo({ commit }, { body }) {
      const { data } = await this.$http.post(`/combos`, body);
      commit("pushCombo", data);
    },
    async updateCombo({ commit }, { id, body }) {
      const { data } = await this.$http.patch(`/combos/${id}`, body);
      commit("refreshCombo", data);
    },
    async deleteCombo({ commit }, { id }) {
      await this.$http.delete(`/combos/${id}`);
      commit("removeCombo", id);
    }
  },
  mutations: {
    setCombos(state, data) {
      state.combos = data;
    },
    pushCombo(state, data) {
      state.combos.push(data);
    },
    refreshCombo(state, data) {
      const combo = state.combos.find(p => p.id == data.id);
      combo.recommended = data.recommended;
      combo.internal = data.internal;
      state.combos = [...state.combos.map(item => item.id !== data.id ? item : {...item, ...combo})]
    },
    removeCombo(state, id) {
      state.combos = state.combos.filter(p => p.id != id);
    }
  }
};
